import React, {useContext} from "react";
import {Fade} from "react-reveal";
import "./ProfessionalJourney.scss";
import {professionalJourney} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";


function cssPx(value, fallback) {
  const number = Number(value);
  if (!Number.isFinite(number)) return `${fallback}px`;
  return `${Math.max(0, number)}px`;
}

function splitParagraphs(text) {
  return String(text || "")
    .replace(/\r\n/g, "\n")
    .split(/\n\s*\n/g)
    .map((p) => p.trim())
    .filter(Boolean);
}

export default function ProfessionalJourney() {
  const {isDark} = useContext(StyleContext);

  if (!professionalJourney?.display) return null;

  const paragraphs = splitParagraphs(professionalJourney.description);
  const spacingStyle = {
    "--sh-professional-journey-title-subtitle-spacing": cssPx(
      professionalJourney.titleSubtitleSpacing,
      24
    ),
    "--sh-professional-journey-subtitle-description-spacing": cssPx(
      professionalJourney.subtitleDescriptionSpacing,
      34
    ),
    "--sh-professional-journey-paragraph-spacing": cssPx(
      professionalJourney.paragraphSpacing,
      20
    ),
  };

  return (
    <section
      id="professional-journey"
      className={`${isDark ? "dark-mode " : ""}professional-journey-main`}
      style={spacingStyle}
    >
      <Fade bottom duration={1000} distance="40px">
        <div className="professional-journey-text-div">
          <h1
            className={
              isDark
                ? "dark-mode professional-journey-heading"
                : "professional-journey-heading"
            }
          >
            {professionalJourney.title}
          </h1>

          {professionalJourney.subtitle ? (
            <p
              className={
                isDark
                  ? "dark-mode subTitle professional-journey-subtitle"
                  : "subTitle professional-journey-subtitle"
              }
            >
              {professionalJourney.subtitle}
            </p>
          ) : null}

          {paragraphs.length > 0 ? (
            <div className="professional-journey-description">
              {paragraphs.map((paragraph, index) => (
                <p
                  key={index}
                  className={
                    isDark
                      ? "dark-mode subTitle professional-journey-text"
                      : "subTitle professional-journey-text"
                  }
                >
                  {paragraph}
                </p>
              ))}
            </div>
          ) : null}
        </div>
      </Fade>
    </section>
  );
}
